import React, { useCallback } from 'react';
import { Text } from 'react-native';
import styles from './styles';
const FormLabel = ({ text, children, ...props }: any) => {
  return (
    <Text style={[styles.labelStyle, styles.labelStyleStandalone]} {...props}>
      {children}
    </Text>
  );
};

export default FormLabel;
